import colors, { appTheme } from '@/config/colors';
import { ResetPassword } from '@/screens/Login/ResetPassword';
import { PublicConfirmationPage } from '@/screens/PublicConfirmationPage';
import { useNavigation } from '@react-navigation/native';
import {
  StackNavigationProp,
  createStackNavigator,
} from '@react-navigation/stack';
import { parse } from 'expo-linking';
import { useEffect } from 'react';
import { Platform } from 'react-native';
import 'typescript/lib/lib.dom.d.ts'; // adds support for web globals as we need them here
import Login from '../screens/Login';
import { SignUpController } from '../screens/Registration/SignUpController';
import { ReactivateAccount } from '@/screens/Login/ReactivateAccount';
import { Filler } from '@/screens/Filler';

export type AnonymousStackParamList = {
  ResetPassword: {
    email?: string;
  };
  EmailVerification: { token: string };
  PublicConfirmationPage: { title: string; text: string };
  SignUpController: undefined;
  Login: {
    email?: string;
  };
  Privacy: undefined;
  ReactivateAccount: {
    reactivationToken: string;
  };
};

const Stack = createStackNavigator<AnonymousStackParamList>();

export function AnonymousStack() {
  const { navigate } =
    useNavigation<StackNavigationProp<AnonymousStackParamList>>();

  useEffect(() => {
    if (Platform.OS !== 'web') return;
    const { queryParams } = parse(location.href);

    if (typeof queryParams?.['email-verified'] === 'string') {
      navigate('PublicConfirmationPage', {
        title: 'Account aktiviert',
        text: 'Vielen Dank für die Verifizierung Ihrer E-Mail-Adresse! \n Sie können die neolexon Aphasie App jetzt auf dem Tablet oder Computer verwenden.',
      });
      history.pushState({}, '', '/');
      return;
    }
    navigate('Login');
  }, []);

  return (
    <Stack.Navigator
      initialRouteName={'Login'}
      screenOptions={{ gestureEnabled: false }}
    >
      <Stack.Screen
        name="Login"
        component={Login}
        options={{ title: 'Login', headerShown: false }}
      />
      <Stack.Screen
        name="ResetPassword"
        component={ResetPassword}
        options={{ title: 'Neues Passwort vergeben', headerShown: false }}
      />
      <Stack.Screen
        name="PublicConfirmationPage"
        component={PublicConfirmationPage}
        options={{ title: 'Neues Passwort vergeben', headerShown: false }}
      />
      <Stack.Screen
        name="ReactivateAccount"
        component={ReactivateAccount}
        options={{ headerShown: false, presentation: 'modal' }}
      />
      <Stack.Screen
        name="Privacy"
        component={Filler}
        options={{
          headerShown: false,
          presentation: 'modal',
        }}
      />
      <Stack.Screen
        name="SignUpController"
        component={SignUpController}
        options={{
          headerTitle: 'Registrierung',
          gestureEnabled: false,
          headerTintColor: colors.white,
          headerStyle: { backgroundColor: appTheme.primary },
          headerLeftContainerStyle: { paddingHorizontal: 8 },
          headerRightContainerStyle: { paddingHorizontal: 16 },
          headerBackTitle: 'Zurück',
          headerMode: 'float',
          headerTitleAlign: 'center',
        }}
      />
    </Stack.Navigator>
  );
}
